export const ONBOARDING_DATA = [
	{
		title: 'Making Implementation as Simple as Possible',
		content: [
			{
				description:
					'Facilities Managers often think that CMMS implementation is hard. We built FacilityBot to challenge that assumption. Yes, there is still work required, for example, to compile the asset registry and source for appropriate preventive maintenance checklists, but we believe that a CMMS software with great UI / UX like FacilityBot can make the process as painless as possible.\n \n All clients benefit from',
				list: [
					`FacilityBot's comprehensive <a href="https://blog.facilitybot.co/knowledge-base/" target='_blank' rel='noreferrer'>Knowledge Base</a> with step-by-step articles and videos for every feature`,
					'A highly configurable architecture for all features',
					'Features built for simplicity and user-friendliness',
					'Many Pagetips, Tooltips, and Help Buttons help clients understand what each page or field does',
					'CSV import for tables which may have a lot of data input, such as assets, meters, licenses, and contracts',
					`Our commitment to continual UI / UX improvement based on <a href="/resources/feature-requests" target='_blank' rel='noreferrer'>client feedback</a>`,
				],
			},
		],
	},

	{
		title: 'Standard Onboarding',
		content: [
			{
				description:
					'All clients enjoy our standard onboarding support. The standard onboarding support is suitable for clients who',
				list: [
					'Do not require help switching from one CMMS to another',
					'Are on a tight budget',
					`Are comfortable spending time going through the <a href="https://blog.facilitybot.co/knowledge-base/" target='_blank' rel='noreferrer'>Knowledge Base</a> videos`,
					'Have experience using a CMMS or preventive maintenance system',
					'Are implementing FacilityBot for a small site with less than 100 assets',
					'Are not looking to integrate with IoT sensors or other custom integrations',
					'Do not need to set up SSO',
					'Do not require on-site support',
				],
			},
			{
				description: 'The standard onboarding support package consists of',
				list: ['A Kick-Off call', 'Up to 4 hours of training calls', 'A 30-day hypercare period'],
			},
			{
				description:
					'Following the hypercare period, clients still benefit from ongoing support from our customer success team based on your subscription plan. However, the FacilityBot client success team will no longer conduct on-site visits or engage in private messaging groups',
				list: undefined,
			},
		],
	},

	{
		title: 'Enhanced Onboarding',
		id: 'enhanced-onboarding',
		content: [
			{
				description:
					'We understand that some clients may wish FacilityBot to provide greater support and are willing to pay for such support. Such clients include those who',
				list: [
					'Need help to migrate data from their existing CMMS to FacilityBot',
					'Need help integrating IoT sensors and other custom integrations',
					'Need help importing the asset register',
					'Need help to populate preventive maintenance checklists',
					'Have a large team that needs training and prefer FacilityBot staff to train them',
					'Have no experience using a CMMS or preventive maintenance system',
					'Needs to set up SSO',
					'Require on-site support',
				],
			},
			{
				description:
					"These clients may wish to use FacilityBot's Enhanced Support Package. The Enhanced onboarding support package consists of",
				list: [
					'A Kick-Off call',
					{
						"Up to 20 hours of assistance from FacilityBot's onboarding team including": [
							'Implementation Project Planning',
							'Training calls',
							'On-Site Training (for supported cities)',
							'Migration Support',
							'SSO setup',
							'Population of Preventive Maintenance Checklists',
							'Assistance to integrate with IoT Sensors',
							'Import and set up Asset Tables',
							'Set up a Custom Dashboard',
							'Any other setup assistance required',
						],
					},
					'A 60-day hypercare period',
				],
			},
			{
				description:
					'Following the hypercare period, clients still benefit from ongoing support from our customer success team based on your subscription plan. However, the FacilityBot client success team will no longer conduct on-site visits or engage in private messaging groups',
				list: undefined,
			},
		],
	},
];
